<template>
    <div>
        <headerNav title="我的意见及反馈" />
        <div>
            <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
            v-model="navitem.loaded"
            :finished="navitem.loadingType == 'nomore' ? true : false"
            :finished-text="navitem.loadingType == 'nomore' ? '没有更多了' : '下拉加载更多'"
            @load="loadData"
            >
                <div v-for="(item, index) in navitem.list" class="mian-list" @click="godetail(item)" :key="index">

                    <div class="mian-list-mark" v-if="item.message">
                        <div v-if="item.isAnswer"><van-tag type="danger" v-if="!item.isRead">未阅</van-tag><van-tag type="success" v-else>已阅</van-tag></div>
                        <div><span style="color:red">我的建议及反馈：</span>{{ item.message }}</div>
                        <div class="mian-list-info-data-last">{{ item.creationTime }}</div>
                        <div class="mian-list-info-data-last"><van-tag type="danger" v-if="!item.isAnswer">未回复</van-tag><van-tag type="success" v-else>已回复</van-tag></div>
                    </div>
                    <!-- <div v-if="item.isAnswer" class="mian-list-mark">
                         <div v-if="item.answerContent"><span style="color:red">客服：</span>{{item.answerContent}}</div>
                        <div class="mian-list-info-data-last">{{ item.answerTime }}</div>
                    </div> -->

                </div>
            </van-list>
            </van-pull-refresh>
        </div>
        
    </div>
</template>
<script>
export default {
    data(){
        return {
            navitem: {
                loadingType: "more",
                loaded: false,
                getparams: {
                    sorting: " isAnswer desc,isRead asc,id asc",
                    maxResultCount: 10,
                    skipCount: 0,
                },
                list: [],
            },
            refreshing:false
        }
    },
    created(){

    },
    methods:{
    onRefresh() {
        this.loadData("refresh");
    },
    loadData(source) {
      let navItem = this.navitem;
      // let state = navItem.state;

      if (source === "tabChange" && navItem.loaded === true) {
        //tab切换只有第一次需要加载数据
        return;
      }
      if (navItem.loadingType === "loading" || navItem.loadingType === "nomore") {
        //防止重复加载
        if (source != "refresh") {
          return;
        }
      }
      if (source === "refresh") {
        this.navitem.list = [];
        this.navitem.getparams.skipCount = 0;
      }
      
      navItem.loadingType = "loading";
      var params = navItem.getparams;
      console.log(this.selectreferralTypes);
      this.navitem.getparams.referralTypes = [];
      
      //加载数据
      this.ajax
        .post("/api/services/app/PhoneCom/QueryIdealList", params)
        .then((x) => {
          this.navitem.getparams.skipCount += this.navitem.getparams.maxResultCount;
          let totalcount = x.result.totalCount;
          this.navitem.list = this.navitem.list.concat(x.result.items);
          //console.log(this.navList);
          // item = Object.assign(item, this.orderStateExp(item.state));
          this.navitem.loadingType =
            totalcount > this.navitem.getparams.skipCount ? "more" : "nomore";
        })
        .finally(() => {
          this.$set(this.navitem, "loaded", false);
          this.refreshing = false;
        });
    },
    godetail(item)
    {
        this.$router.push({path:'/idealdetail',query:{id:item.id}});
    }
    }
}
</script>
<style lang="scss" scoped>

.mian-list {
  background-color: #fff;
  font-size: 12px;
  border-radius: 8px;
  margin: 10px 40px;
  padding: 5px 20px;
  box-shadow: 1px 1px 4px #c3c3c3;
  line-height: 18px;
}



.mian-list-info-data-last {
  text-align: right;
}


.mian-list-mark {
  
  padding-bottom: 5px;
  font-size: 15px;
}
</style>